import { Component, OnInit } from '@angular/core';
import {
	FormBuilder,
	FormGroup,
	Validators
} from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

import { UserService } from '../../../../core/services/user.service';
import { MustMatch } from '../../../../core/helpers/must-match.validator';

@Component({
	selector: 'app-change-password-modal',
	templateUrl: './change-password-modal.component.html',
	styleUrls: ['./change-password-modal.component.scss']
})

export class ChangePasswordModalComponent implements OnInit {
	changePasswordForm: FormGroup;
	user: any;
	isFormSubmitted = false;

	constructor (
		public translate: TranslateService,
		public bsModalRef: BsModalRef,
		private formBuilder: FormBuilder,
		private toastr: ToastrService,
		private userService: UserService
	) { }

	ngOnInit() {
		this.loadForms();
	}

	loadForms() {
		this.changePasswordForm = this.formBuilder.group({
			id: this.user.id,
			old_password: [null, Validators.required],
			password: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(30)]],
			password_confirmation: [null, Validators.required],
		}, {
			validator: MustMatch('password', 'password_confirmation')
		});
	}

	get formControl() { return this.changePasswordForm.controls; }

	onSubmit() {
		this.isFormSubmitted = true;
		if (this.changePasswordForm.invalid) {
			return;
		}

		this.userService.changePassword(this.changePasswordForm.value)
			.subscribe(
				data => {
					this.toastr.success("Password change successfully", this.translate.instant('users.title'));
					this.onCancel();
				},
				error => {}
			);
	}

	onCancel() {
		this.bsModalRef.hide();
	}
}
